/*
 *  Copyright (c) 2024. Rapida
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy
 *  of this software and associated documentation files (the "Software"), to deal
 *  in the Software without restriction, including without limitation the rights
 *  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *  copies of the Software, and to permit persons to whom the Software is
 *  furnished to do so, subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in
 *  all copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 *  THE SOFTWARE.
 *
 *  Author: Prashant <prashant@rapida.ai>
 *
 */

export const HEADER_AUTH_ID = 'x-auth-id';
export const HEADER_PROJECT_ID = 'x-project-id';

export const HEADER_API_KEY = 'x-api-key';
export const HEADER_SOURCE_KEY = 'x-client-source';
export const HEADER_ENVIRONMENT_KEY = 'x-rapida-environment';
export const HEADER_REGION_KEY = 'x-rapida-region';

export const HEADER_USER_AGENT = 'x-user-agent';
export const HEADER_LANGUAGE = 'x-language';
export const HEADER_PLATFORM = 'x-platform';
export const HEADER_SCREEN_WIDTH = 'x-screen-width';
export const HEADER_SCREEN_HEIGHT = 'x-screen-height';
export const HEADER_WINDOW_WIDTH = 'x-window-width';
export const HEADER_WINDOW_HEIGHT = 'x-window-height';
export const HEADER_TIMEZONE = 'x-timezone';
export const HEADER_COLOR_DEPTH = 'x-color-depth';
export const HEADER_DEVICE_MEMORY = 'x-device-memory';
export const HEADER_HARDWARE_CONCURRENCY = 'x-hardware-concurrency';
export const HEADER_CONNECTION_TYPE = 'x-connection-type';
export const HEADER_CONNECTION_EFFECTIVE_TYPE = 'x-connection-effective-type';
export const HEADER_COOKIES_ENABLED = 'x-cookies-enabled';
export const HEADER_DO_NOT_TRACK = 'x-do-not-track';
export const HEADER_REFERRER = 'x-referrer';
export const HEADER_REMOTE_URL = 'x-remote-url';
export const HEADER_LATITUDE = 'x-latitude';
export const HEADER_LONGITUDE = 'x-longitude';
